import React, { createContext, useContext } from 'react'

// Ebene der naechsten umgebenden Ueberschrift. Ohne Angabe 2: die Abschnitte
// stehen im Shortcode unter dessen h2 (oder der Ueberschrift der
// Elementor-Seite) — ihre eigenen Ueberschriften sind dort h3 (#236).
const Ebene = createContext(2)

// Setzt die Ebene, unter der die Ueberschriften im Inneren stehen.
export const UnterEbene = ({ ebene, children }) => <Ebene.Provider value={ebene}>{children}</Ebene.Provider>

// Eine Ueberschrift eine Ebene unter der umgebenden — die Gliederung folgt der
// Seite, das Aussehen bleibt Sache der Klasse.
export const Ueberschrift = ({ children, ...props }) => {
    const Tag = `h${Math.min(useContext(Ebene) + 1, 6)}`

    return <Tag {...props}>{children}</Tag>
}
